import { lazy } from "react";

import Suspense from "components/shared/Suspense";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { PageSerializersSeriesShow } from "types/serializers";

const ReportSeriesContent = lazy(() => import("./FlagSeriesButton"));

export interface Props {
  series: PageSerializersSeriesShow;
}

export default function ReportSeriesButton({ series }: Props) {
  const isLoggedIn = useIsLoggedIn();

  if (!isLoggedIn) {
    return <></>;
  }

  return (
    <Suspense>
      <ReportSeriesContent series={series} />
    </Suspense>
  );
}
